/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from 'react';
import { SvgHandler } from '../../../../../../isomorphic/components/svg-handler/svg-handler';
import closeIcon from '../../../../../../assets/icons/social/close.svg';
import './pop-up.m.css';

export const Popup = ({ message, title, onClose, buttonsData }) => {
  return (
    <div styleName='content-wrapper'>
      <div styleName='overlay'>
        <div styleName='wrapper'>
          {title && <div styleName='title'>{title}</div>}
          <div styleName={'content'} dangerouslySetInnerHTML={{ __html: message }} />
          {buttonsData?.map(({ styleName, onClick, name }) => (
            <button styleName={styleName} onClick={onClick}>
              {name}
            </button>
          ))}
          <div styleName='close' onClick={() => onClose()}>
            <SvgHandler width='24' height='24' xlinkHref={closeIcon} />
          </div>
        </div>
      </div>
    </div>
  );
};
